// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-__Receipt___ENoFG","action-bar":"app-pages-AccountSetting-Receipt-__Receipt___20xMz","container":"app-pages-AccountSetting-Receipt-__Receipt___3f1gG","receipt-info-wrapper":"app-pages-AccountSetting-Receipt-__Receipt___1w-2-","receipt-preview-wrapper":"app-pages-AccountSetting-Receipt-__Receipt___1sGtX"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/Receipt/Receipt.css
// module id = 2288
// module chunks = 0